import React, { Component } from 'react';
import getLocale from '../../../i18n/getLocale';
class SchedulesElaborateBasesDates extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      hidden: this.props.hidden,
      key: this.props.key,
      data: this.props.data,
    };

    this.locale = getLocale();
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.data.infos !== 'undefined')) {
      this.setState({
        key: newProps.key,
        data: newProps.data,
        loaded: 1,
      });
    }
  }

  

  render() {
    var self = this;
    return (
<div>
  <h3>{this.locale.Escalas.ElaboracaoDeEscala.tabDatas.tituloEscalaDe} {self.state.data['infos']['name']} - {self.state.data['infos']['model']}</h3>
  <hr/>
  <div className="listing table-responsive">
    <table className="table table-bordered table-striped table-hover">
      <thead>
        <tr>
          <th>{this.locale.Escalas.ElaboracaoDeEscala.tabDatas.tabela.Nome}</th>
          <th>{this.locale.Escalas.ElaboracaoDeEscala.tabDatas.tabela.Escala}</th>
          <th>{this.locale.Escalas.ElaboracaoDeEscala.tabDatas.tabela.Base}</th>
          <th>{this.locale.Escalas.ElaboracaoDeEscala.tabDatas.tabela.Aeronave}</th>
          <th>{this.locale.Escalas.ElaboracaoDeEscala.tabDatas.tabela.TotalHoras}</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(self.state.data["staffs"]).map(function(s) {
          return (
            <tr>
              <td>{self.state.data["staffs"][s]["name"]}</td>
              <td>{self.state.data["staffs"][s]["schedule_type"]}</td>
              <td>{self.state.data["staffs"][s]["bases"]}</td>
              <td>{self.state.data["staffs"][s]["aircraft"]}</td>
              <td>
                  {(self.state.data["staffs"][s]["total_h"] > 50) ?
                    self.state.data["staffs"][s]["total_h"]
                  : 
                    <span style={{color:'red'}}>{self.state.data["staffs"][s]["total_h"]}</span>
                  }
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
</div>
    );
  }
}

export default SchedulesElaborateBasesDates;



// WEBPACK FOOTER //
// ./src/Components/Schedules/Elements/SchedulesElaborateBasesDates.js